import React, { useCallback, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Menu, { MenuItem } from '../../../shared/components/Menu/Menu';
import Tooltip from '../../../shared/components/Tooltip/Tooltip';

export default function QuoteContextMenu({ label, ariaLabel = label, items, primary = false, className = '' }) {
  const anchor = useRef(null), id = useId();
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const keyboard = event => {
    event.stopPropagation();
    const entries = [...event.currentTarget.querySelectorAll('[role="menuitem"]')];
    const index = entries.indexOf(document.activeElement);
    if (event.key === 'Escape') { event.preventDefault(); close(); anchor.current.focus(); }
    if (event.key === 'Tab') close();
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? entries.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + entries.length) % entries.length;
    entries[next]?.focus();
  };
  return <>
    <button ref={anchor} className={`basic-button quote-menu-trigger ${primary ? 'active' : ''} ${className}`} type="button" aria-label={ariaLabel} aria-haspopup="menu" aria-expanded={open} aria-controls={open ? id : undefined} onClick={() => setOpen(!open)}>{label}<span aria-hidden="true">⌄</span></button>
    {open && createPortal(<Menu id={id} open anchorEl={anchor.current} anchorRef={anchor} onClose={close} className="quote-context-menu" aria-label={ariaLabel} onKeyDown={keyboard}>
      {items.filter(Boolean).map((item, index) => <Tooltip portal key={`${item.label}:${index}`} label={item.help || item.label}>
        <MenuItem aria-disabled={!!item.disabled} danger={item.danger} title={item.help} onClick={() => { if (!item.disabled) { close(); item.onClick(); } }}>{item.label}</MenuItem>
      </Tooltip>)}
    </Menu>, document.body)}
  </>;
}
